<!-- 外卖订单详情 -->
<template>
    <div class="home">
        <van-nav-bar
		  	:title="$t('order.title')"
			left-arrow
			fixed
			z-index='9'
		  	@click-left="$router.go(-1)">
		</van-nav-bar>
        <div class="wrapper">
            <!-- <div class="orderAddress">
                <div style="padding:10px;font-size:18px;font-weight:bold">配送地址</div>
                <div class="address" v-if="orderDetail.order_address">
                    <div style="font-size:18px;padding:15px">{{orderDetail.order_address.name}} {{orderDetail.order_address.phone}}</div>
                    <div style="padding-left:15px">{{orderDetail.order_address.province+orderDetail.order_address.city+orderDetail.order_address.area+orderDetail.order_address.address}}</div>
                </div>
            </div> -->
            <div class="orderAddress">
                <div style="padding:10px;font-size:18px;font-weight:bold">取餐用户信息</div>
                <div class="address" v-if="orderDetail.order_address">
                    <van-cell :title="$t('order.ticket')" :value="orderDetail.ticket" />
                    <van-cell :title="$t('NewShop.name')" :value="orderDetail.order_address.name" />
                    <van-cell :title="$t('NewShop.phone')" :value="orderDetail.order_address.phone" />
                </div>
            </div>
            <div class="detail">
                <div style="padding:10px;font-size:18px;font-weight:bold">订单信息</div>
                <div class="address">
                    <van-cell title="订单金额" :value="orderDetail.final_price" />
                    <van-cell title="订单状态" :value="orderDetail.status ==0 ?'正在做':'已做完'" />
                    <van-cell title="订单号" :value="orderDetail.order" />
                    <van-cell title="下单时间" :value="orderDetail.created_at" />
                </div>
            </div>
            <div class="detail">
                <div style="padding:10px;font-size:18px;font-weight:bold">订单详情</div>
                <div class="dishesWrapper">
                    <div class="orderDishes" v-if="orderDetail">
                        <template v-for="(dish,index) in orderDetail.package">
                            <div class="dishItem">
                                <div class="dishDetail">
                                    <div class="dish_name noExceed">{{dish.menu_name}}</div>
                                    <div class="dish_price price">X{{dish.number}}</div>
                                    <div class="dish_num noExceed tr">{{sessionStorage.getItem('currency')}}{{dish.price}}</div>
                                    <div v-if="dish.category=='m'" class="dish_des noExceed">
                                        <template v-for="val in dish.tags_name">
                                            {{val}}
                                        </template>
                                        {{dish.remark}}
                                    </div>
                                </div>
                                <template v-for="(son,key) in dish.details" >
                                    <div class="dishDetail son">
                                        <div class="dish_name noExceed">{{son.menus_name}}</div>
                                        <div class="dish_num"></div>
                                        <div class="dish_price noExceed">
                                            
                                        </div>
                                        <div class="dish_des noExceed">
                                            <template v-for="val in son.tags_name">
                                                {{val}}
                                            </template>
                                            {{son.remark}}
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div style="height: 2px;width: 100%;background-color: #eee;"></div>
                        </template>
                    </div>
                </div>
            </div>  
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            orderDetail:[],
        };
    },
    mounted(){
        this.getOrderDetail();
    },
    methods:{
        // 获取订单详情
        getOrderDetail(){
            this.$axios({
				method: 'PUT',
				url: this.$build+'/api/order/'+this.$route.params.id+'/takeIndex',
            }).then(res => {
                console.log(res);
                if(res.data.status==200){
					this.orderDetail = res.data.data;
                }else{
                    for (var item in res.data.error) {
                        this.$toast({
                            type:'fail',
                            message:res.data.error[item],
                        });
                    }
                }
            }).catch(err => {
                this.$toast({
                    type:'fail',
                    message:this.$t('common.message'),
                });
            });
        },
    }
}

</script>
<style scoped>
    /deep/ .van-nav-bar .van-icon{
		font-size: 26px;
		color: #fff;
	}
    .wrapper{
        /* padding-top: 46px; */
        padding-bottom: 55px;
    }
    .address{
        min-height: 90px;
        background:#fff;
        margin:0 auto;
        border-radius: 10px;
    }
    .dishesWrapper{
        background:#fff;
        margin:0 auto;
    }
    /deep/ .van-cell__value{
        word-wrap:inherit
    }
    /deep/ .van-nav-bar__right .van-nav-bar__text{color: #fff;}
    
    .home{
		width: 100%;
		height: 100%;
	}
    .orderDishes{
        width: 100%;
        min-height: 50px;
    }
    .dishItem{
        width: 90%;
        margin-left: 5%;
        min-height: 35px;
        position: relative;
    }
    .dish_name{
        width: 60%;
        height: 35px;
        line-height: 35px;
        float: left;
    }
    .dish_num{
        width: 15%;
        height: 35px;
        line-height: 35px;
        float: left;
        color: #000;
    }
    .dish_price{
        width: 25%;
        height: 35px;
        line-height: 35px;
        color: #000;
        float: left;
        text-align: right;
    }
    .dishDetail .price{
        text-align: left;
        color: #000;
    }
    .dish_des{
        width: 100%;
        height: 20px;
        color: #999;
        clear: both;
        font-size: 14px;
    }
    .leftdot{
        position: absolute;
        width: 6px;
        height: 6px;
        left: -3.5%;
        top: 15px;
        background: #2f75f4;
        color: #fff;
        border-radius: 50%;
    }
    .totalPrice{
        width: 100%;
        height: 20px;
        line-height:20px;
        font-size: 16px;
        text-align: right; 
    }
    .son>div{
        height: 20px;
        line-height: 20px;
        font-size: 14px;
    }
    .shopBottom{
        position: fixed;
        bottom: 0;
        height: 50px;
        background: #fff;
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #ccc;
    }
    .certainBtn{
        top:2px;
        width: 95%;
        background:#2f75f4;
        color: #fff;
        font-weight: bold;
        font-size: 16px;
        margin:0 auto;
    }
    .cancelBtn{
        top:2px;
        width: 95%;
        background:#ccc;
        font-weight: bold;
        font-size: 16px;
        margin:0 auto;
    }
    .orderInfo{
        width:90%;
        margin-left: 5%;
        height: 60px;
        padding-top: 5px;
    }
    .infoItem{
        width: 100%;
        height: 25px;
        font-size: 14px;
        display: flex;
        display: -webkit-flex;
        align-items: center;
        justify-content: space-between;
    }
    .info_left{
        flex: auto;
        text-align: left;
        height: 25px;
        line-height: 25px; 
    }  
    .info_right{
        flex: auto;
        text-align: right;
        height: 25px;
        line-height: 25px;
    }
    .menuIconGroup{
        height: 35px;
    }
    .type_icon{
        width: 50%;
        height: 35px;
        line-height: 35px;
        float: left;
        display: flex;
        display: -webkit-flex;
        align-items: center;
    }
    .type_icon>span{
        font-size: 14px;
        text-indent: 10px;
    }
    .row1{
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
    }
    .bottom{
        width: 100%;
        height: 45px;
        background: #FFC813;
        font-size: 18px;
        color: #fff;
        text-align: center;
        line-height: 45px;
        position: fixed;
        bottom: 0;
    }
</style>


// WEBPACK FOOTER //
// src/Shop/TakeOrderDetail.vue